import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where, orderBy, limit } from 'firebase/firestore';
import { firestore } from '../config/firebaseConfig';
import Modal from 'react-modal';
import EnviarPilula from '../components/EnviarPilula';
import Simulador from '../components/Simulador';
import { PiQueue } from "react-icons/pi";
// import './MonitoraFila.css';

const Monitorafila = () => {
  const [latestQuestaoLog, setLatestQuestaoLog] = useState(null); // Última questão enviada
  const [latestPilulaLog, setLatestPilulaLog] = useState(null);   // Última pílula enviada
  const [nextQuestao, setNextQuestao] = useState(null);           // Próxima questão
  const [nextPilula, setNextPilula] = useState(null);             // Próxima pílula
  const [error, setError] = useState('');
  
  const [isSimuladorModalOpen, setIsSimuladorModalOpen] = useState(false);
  const openSimuladorModal = () => setIsSimuladorModalOpen(true);
  const closeSimuladorModal = () => setIsSimuladorModalOpen(false);
  const [isPilulaModalOpen, setIsPilulaModalOpen] = useState(false);
  const openPilulaModal = () => setIsPilulaModalOpen(true);
  const closePilulaModal = () => setIsPilulaModalOpen(false);

  Modal.setAppElement('#root');
  

  const tenantId = localStorage.getItem('tenantId') || 'unknownTenant'; // Obtém o tenantId do localStorage

  // Função para formatar a data
  const formatDate = (timestamp) => {
    const today = new Date();
    const givenDate = new Date(timestamp * 1000);

    if (today.toDateString() === givenDate.toDateString()) {
      return `Hoje às ${givenDate.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      })}`;
    }

    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (yesterday.toDateString() === givenDate.toDateString()) {
      return `Ontem às ${givenDate.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      })}`;
    }

    return `${givenDate.toLocaleDateString('pt-BR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })} às ${givenDate.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    })}`;
  };

  useEffect(() => {
    // Função para buscar o último log de questão enviada
    const fetchLatestQuestaoLog = async () => {
      try {
        const questoesLogsRef = collection(firestore, 'logEnvioQuestao');
        const questoesQuery = query(
          questoesLogsRef, 
          where('tenantId', '==', tenantId),  // Filtra pelo tenantId
          orderBy('timestamp', 'desc'),  // Alterado de 'datahora' para 'timestamp'
          limit(1)
        );
        const questoesSnapshot = await getDocs(questoesQuery);
        const latestQuestao = questoesSnapshot.docs.length ? questoesSnapshot.docs[0].data() : null;
        setLatestQuestaoLog(latestQuestao);
      } catch (error) {
        console.error('Erro ao buscar o último log de questões:', error);
        setError('Erro ao buscar o último log de questões.');
      }
    };

    // Função para buscar o último log de pílula enviada
    const fetchLatestPilulaLog = async () => {
      try {
        const pilulasLogsRef = collection(firestore, 'logEnvioPilula');
        const pilulasQuery = query(
          pilulasLogsRef, 
          where('tenantId', '==', tenantId),  // Filtra pelo tenantId
          orderBy('datahora', 'desc'), 
          limit(1)
        );
        const pilulasSnapshot = await getDocs(pilulasQuery);
        const latestPilula = pilulasSnapshot.docs.length ? pilulasSnapshot.docs[0].data() : null;
        setLatestPilulaLog(latestPilula);
      } catch (error) {
        console.error('Erro ao buscar o último log de pílulas:', error);
        setError('Erro ao buscar o último log de pílulas.');
      }
    };

    // Função para buscar a próxima questão (prioridade >= 1 primeiro, depois prioridade 0)
    const fetchNextQuestao = async () => {
      try {
        const questoesRef = collection(firestore, 'questoes');

        // Primeiro, buscar a questão com prioridade >= 1
        let questoesQuery = query(
          questoesRef,
          where('enviado', '==', false),    // Questão que ainda não foi enviada
          where('bloqueado', '==', false),  // Questão não bloqueada
          where('tenantId', '==', tenantId), // Filtra pelo tenantId
          where('prioridade', '>=', 1),     // Prioridade maior ou igual a 1
          orderBy('prioridade', 'asc'),     // Ordena por prioridade
          orderBy('createdAt', 'asc'),      // Ordena por data de criação
          limit(1)                          // Limita a próxima questão a ser enviada
        );

        let questoesSnapshot = await getDocs(questoesQuery);
        let nextQuestaoData = questoesSnapshot.docs.length ? questoesSnapshot.docs[0].data() : null;

        // Se nenhuma questão com prioridade >= 1 for encontrada, buscar a questão com prioridade 0
        if (!nextQuestaoData) {
          questoesQuery = query(
            questoesRef,
            where('enviado', '==', false),
            where('bloqueado', '==', false),
            where('tenantId', '==', tenantId), // Filtra pelo tenantId
            where('prioridade', '==', 0),    // Prioridade igual a 0
            orderBy('createdAt', 'asc'),     // Ordena por data de criação
            limit(1)
          );

          questoesSnapshot = await getDocs(questoesQuery);
          nextQuestaoData = questoesSnapshot.docs.length ? questoesSnapshot.docs[0].data() : null;
        }

        setNextQuestao(nextQuestaoData);
      } catch (error) {
        console.error('Erro ao buscar a próxima questão:', error);
        setError('Erro ao buscar a próxima questão.');
      }
    };

    // Função para buscar a próxima pílula (prioridade >= 1 primeiro, depois prioridade 0)
    const fetchNextPilula = async () => {
      try {
        const pilulasRef = collection(firestore, 'pilulas');
    
        // 1️⃣ Primeiro busca pílulas com PRIORIDADE >= 1 (não enviadas/não bloqueadas)
        const queryPrioritarias = query(
          pilulasRef,
          where('tenantId', '==', tenantId),
          where('enviado', '==', false),
          where('bloqueado', '==', false),
          where('prioridade', '>=', 1),
          orderBy('prioridade', 'desc'),  // Maior prioridade primeiro!
          orderBy('createdAt', 'asc'),    // Em caso de empate, pega a mais antiga
          limit(1)
        );
    
        const snapshotPrioritarias = await getDocs(queryPrioritarias);
        const pilulaPrioritaria = snapshotPrioritarias.docs[0]?.data();
    
        // 2️⃣ Se NÃO achou prioritárias, busca PRIORIDADE 0
        if (!pilulaPrioritaria) {
          const queryNaoPrioritarias = query(
            pilulasRef,
            where('tenantId', '==', tenantId),
            where('enviado', '==', false),
            where('bloqueado', '==', false),
            where('prioridade', '==', 0),
            orderBy('createdAt', 'asc'),
            limit(1)
          );
    
          const snapshotNaoPrioritarias = await getDocs(queryNaoPrioritarias);
          const pilulaNaoPrioritaria = snapshotNaoPrioritarias.docs[0]?.data();
          setNextPilula(pilulaNaoPrioritaria || null);
        } else {
          setNextPilula(pilulaPrioritaria);
        }
    
      } catch (error) {
        console.error("Erro ao buscar pílula:", error);
        setError("Falha ao carregar pílulas.");
      }
    };

    fetchLatestQuestaoLog();
    fetchLatestPilulaLog();
    fetchNextQuestao();
    fetchNextPilula();
  }, [tenantId]);  // Adicionamos o tenantId como dependência do useEffect para garantir que atualize corretamente

  return (
    <div className="monitorafila-container">
      
      <h4>MONITORAMENTO</h4>
      {error && <p>{error}</p>}
  
      <div className="quadrants">
        {/* Última questão enviada */}
        <div className="quadrant latest-questao">
          <h4>Última Questão</h4>
          {latestQuestaoLog ? (
            <div>
              <p>{latestQuestaoLog.enunciado || 'N/A'}</p>
              <p>{formatDate(latestQuestaoLog.timestamp.seconds)}</p>
            </div>
          ) : (
            <p>Nenhum envio registrado.</p>
          )}
        </div>
        
        {/* Próxima questão agendada */}
        <div className="quadrant next-questao">
          <h4>Próxima Questão</h4>
          {nextQuestao ? (
            <div>
              <p>{nextQuestao.enunciado || 'N/A'}</p>
              {/* <p>{formatDate(nextQuestao.createdAt.seconds)}</p> */}
              
      <span onClick={openSimuladorModal} className="open-modal-link">
      <PiQueue size="25"/>
      Processar Fila
      </span>
            </div>
          ) : (
            <p>Nenhuma questão agendada.</p>
          )}
        </div>
  
        {/* Última pílula enviada */}
        <div className="quadrant latest-pilula">
          <h4>Última Pílula</h4>
          {latestPilulaLog ? (
            <div>
              <p>{latestPilulaLog.titulo || 'N/A'}</p>
              <p>{formatDate(latestPilulaLog.datahora.seconds)}</p>
            </div>
          ) : (
            <p>Nenhum envio registrado.</p>
          )}
        </div>
        
        {/* Próxima pílula agendada */}
        <div className="quadrant next-pilula">
          <h4>Próxima Pílula</h4>
          {nextPilula ? (
            <div>
              <p>{nextPilula.titulo || 'N/A'}</p>
              {/*<p>{formatDate(nextPilula.createdAt.seconds)}</p>*/}

            <span onClick={openPilulaModal} className="open-modal-link">
            <PiQueue size="25"/>
            Processar Fila
            </span>
            </div>
          ) : (
            <p>Nenhuma pílula agendada.</p>
          )}
        </div>
      </div>

      {/* Modal do Simulador */}
      <Modal
        isOpen={isSimuladorModalOpen}
        onRequestClose={closeSimuladorModal}
        contentLabel="Simulador"
        className="modal-content"
        overlayClassName="modal-overlay"
      >        
        {/* <button onClick={closeSimuladorModal} className="close-modal-button">Fechar</button> */}
        <Simulador onCancel={closeSimuladorModal} />
      </Modal>

      {/* Modal para Pílulas */}
      <Modal
        isOpen={isPilulaModalOpen}
        onRequestClose={closePilulaModal}
        contentLabel="Enviar Pílula"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        
        {/* <button onClick={closePilulaModal} className="close-modal-button">Fechar</button> */}
        <EnviarPilula onCancel={closePilulaModal} />


      </Modal>
    </div>
  );
};

export default Monitorafila;
